export default {
  link: {
    base: {
      borderBottom: 'none',
      fontSize: ['xxs', 'xxs'],
      lineHeight: 'xl',
      mr: 2,
      textDecoration: 'none',
      textUnderlineOffset: '1px',
      ':not(:hover):not(:focus)': {
        color: 'grey-70'
      }
    },
    variants: {
      hover: {
        variant: 'spark.element.breadcrumbs.link.base',
        color: 'grey-80',
        borderBottomColor: 'transparent',
        textDecoration: 'underline'
      },
      focus: {
        variant: 'spark.element.breadcrumbs.link.base',
        color: 'primary',
        borderBottomColor: 'transparent',
        outlineStyle: 'solid',
        outlineWidth: 2,
        outlineColor: 'orange',
        backgroundColor: 'transparent'
      },
      last: {
        variant: 'spark.element.breadcrumbs.link.base',
        fontWeight: 'bold',
        cursor: 'default'
      }
    }
  },
  separator: {
    base: {
      marginTop: '2px',
      fontSize: 20,
      variant: 'spark.element.breadcrumbs.link.base',
      ':hover': {
        color: 'grey-60'
      }
    }
  }
};